import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../button";
import { ErrorBanner } from "../error-banner";
import { FormHeader } from "../form-header";
import { SSNField } from "../ssn-field";
import { cn } from "../utils";
import { createRecoverFormButtonProps } from "./recover-form-button-props";
import { recoverFormButtonGroupStyles, recoverFormContentStyles, recoverFormErrorStyles, recoverFormStyles, } from "./recover-form-layout.styles";
function RecoverFormSsnField({ form, }) {
    return (_jsx("div", { className: "form-group", children: _jsx(SSNField, { form: form, name: "ssn", showBootstrap: true, variant: "outlined" }) }));
}
function RecoverFormActionButtons({ copy, buttonProps, useMobileNext, buttonClassName, className, }) {
    const nextProps = useMobileNext ? buttonProps.nextMobile : buttonProps.next;
    return (_jsxs("div", { className: cn(recoverFormButtonGroupStyles(), className), children: [_jsx(Button, { ...nextProps, className: buttonClassName, children: copy.next }), _jsx(Button, { ...buttonProps.cancel, className: buttonClassName, children: copy.cancel })] }));
}
/**
 * Shared responsive shell for recover email / password personal-info steps.
 */
export function RecoverFormLayout({ copy, form, onFormSubmit, onCancel, onMobileNext, isLoading = false, isSubmitDisabled = false, error = null, errorBannerRef, headerTestId, "data-testid": dataTestId, fieldsTestId, errorTestId, errorBannerTestId, mobileButtonsOutsideForm = false, children, }) {
    const buttonProps = createRecoverFormButtonProps({
        isLoading,
        isSubmitDisabled,
        onCancel,
        onMobileNext,
    });
    const desktopButtons = (_jsx(RecoverFormActionButtons, { copy: copy, buttonProps: buttonProps, useMobileNext: false, buttonClassName: "flex-1", className: "hidden md:flex" }));
    const mobileButtons = (_jsx(RecoverFormActionButtons, { copy: copy, buttonProps: buttonProps, useMobileNext: Boolean(onMobileNext), buttonClassName: "w-full", className: "md:hidden" }));
    let formMobileButtons = null;
    let outsideFormMobileButtons = null;
    if (mobileButtonsOutsideForm) {
        outsideFormMobileButtons = mobileButtons;
    }
    else {
        formMobileButtons = mobileButtons;
    }
    let errorBanner = null;
    if (error) {
        errorBanner = (_jsx("div", { ref: errorBannerRef, className: cn(recoverFormErrorStyles()), "data-testid": errorTestId, children: _jsx(ErrorBanner, { message: error, testID: errorBannerTestId }) }));
    }
    return (_jsxs("div", { className: cn(recoverFormStyles()), "data-testid": dataTestId, children: [_jsx(FormHeader, { title: copy.title, description: copy.description, testId: headerTestId }), _jsx("div", { className: cn(recoverFormContentStyles()), children: _jsxs("form", { onSubmit: onFormSubmit, className: "space-y-4 md:space-y-6", "data-testid": fieldsTestId, children: [children, _jsx(RecoverFormSsnField, { form: form }), desktopButtons, formMobileButtons] }) }), outsideFormMobileButtons, errorBanner] }));
}
//# sourceMappingURL=RecoverFormLayout.js.map